import { serverApiUrl } from "../index"

export const sendOtp = async (phone) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  

    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    try {
        const response = await fetch(serverApiUrl + '/institute/generateInsOtp/' + phone,
            {
                method: 'GET',
            })
        if (response.status === 200) {
            const data = await response.json()
            return { status: true, data: data }
        } else {
            throw new Error("something went wrong " + response.status)
        }

    } catch (e) {
        return { status: false, error: e.message }
    }


}

export const verifyOtp = async (otpValue, mobileNumber) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    try {
        const response = await fetch(serverApiUrl + '/institute/validateInsOtp/',
            {
                method: 'POST',
                headers,
                body: JSON.stringify({ otpValue, mobileNumber })
            })
        if (response.status == 200) {
            const data = await response.json()
            return { status: true, data: data }
        } else {
            throw new Error("something went wrong " + response.status)
        }

    } catch (e) {
        return { status: false, error: e.message }
    }
}

export const validateAccessToken = async (validateAccessToken) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', validateAccessToken);
    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    try {
        const response = await fetch(serverApiUrl + '/institute/validateAccessToken/',
            {
                method: 'GET',
                headers,
            })
        if (response.status == 200) {
            const data = await response.json()
            return { status: true, data: data }
        } else {
            throw new Error("something went wrong " + response.status)
        }

    } catch (e) {
        return { status: false, error: e.message }
    }
}

export const passwordReset = (password, hash1, hash2, callback) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers();

    headers.append('Content-Type', 'application/json');

    headers.append('Access-Control-Allow-Origin', serverApiUrl);
    headers.append('Access-Control-Allow-Credentials', 'true');

    headers.append('GET', 'POST', 'OPTIONS');
    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    fetch(serverApiUrl + 'institute/resetPassword',
        {
            method: 'POST',
            headers,
            body: JSON.stringify({ hash1, hash2, password })
        })
        .then((response) => callback(response))
        .catch((error) => { console.log(error) })
}


export const forgotPassword = (email, callback) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers();

    headers.append('Content-Type', 'application/json');

    headers.append('Access-Control-Allow-Origin', serverApiUrl);
    headers.append('Access-Control-Allow-Credentials', 'true');

    headers.append('GET', 'POST', 'OPTIONS');
    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    fetch(serverApiUrl + 'institute/forgotPassword?email=' + email,
        {
            method: 'GET',
            headers,

        })
        .then((response) => callback(response))
        .catch((error) => { console.log(error) })
} 
